export interface LoginActivity {
  id: string;
  userId: string;
  userName: string;
  email: string;
  ipAddress: string;
  city: string;
  country: string;
  status: string;
  createdAt: string;
}

/**
 * Mirrors the backend `SortBy` enum, which is shared by every report endpoint.
 * Only the members below change the order of login activity — the endpoint accepts
 * the other values and then falls back to sorting by `createdAt`.
 */
export enum LoginActivitySortBy {
  Date = 2,
  Email = 4,
  Status = 7,
  IpAddress = 8,
  /** Country first, then city. */
  Location = 9
}

/** Mirrors the backend `SortOrder` enum. */
export enum LoginActivitySortOrder {
  Ascending = 0,
  Descending = 1
}

export interface LoginActivityQuery {
  /** `yyyy-MM-dd`. `null` leaves that end of the range open. */
  fromDate: string | null;
  toDate: string | null;
  pageNumber: number;
  pageSize: number;
  sortBy: LoginActivitySortBy;
  sortOrder: LoginActivitySortOrder;
}

export interface LoginActivityPage {
  activities: LoginActivity[];
  /** The endpoint reports no total count, so this is probed by over-fetching a row. */
  hasNextPage: boolean;
}

export interface SigninFormValues {
  email: string;
  password: string;
  rememberMe: boolean;
}
